import React, { useState } from 'react';
import { ToggleButtonItem, ToggleButton, ToggleButtonLayoutStyle, Panel, PanelTheme } from '@apply/components';
import { DemoSection } from './common/SectionNavigator';
import { DemoExample, DemoPage, DemoPageSection } from './common/DemoLayout';

const sections: DemoSection[] = [
    { id: 'toggleButtonDemo_vertical', title: 'Vertical' },
    { id: 'toggleButtonDemo_horizontal', title: 'Horizontal' },
];

export const ToggleButtonDemo: React.FC = () => {
    const [moneySelected, set_moneySelected] = useState<string[]>(['dollar']);
    const [yesNoSelected, set_yesNoSelected] = useState<string[]>(['Yes']);
    const [moneySelectedWithBubble, set_moneyWithBubbleSelected] = useState<string[]>(['dollar']);
    const [yesNoSelectedWithBubble, set_yesNoWithBubbleSelected] = useState<string[]>(['Yes']);
    const [horizontalYesNoSelected, set_horizontalYesNoSelected] = useState<string[]>(['Yes']);
    const [horizontalMoneySelected, set_horizontalMoneySelected] = useState<string[]>(['dollar']);
    const [horizontalYesNoSelectedWithBubble, set_horizontalYesNoWithBubbleSelected] = useState<string[]>(['Yes']);
    const [horizontalMoneySelectedWithBubble, set_horizontalMoneyWithBubbleSelected] = useState<string[]>(['dollar']);

    // Label column width shared by the horizontal examples so the buttons line up.
    const horizontalLabelWidth = '270px';

    const yesNoButtonItems: ToggleButtonItem[] = [
        {
            id: 'Yes',
            text: 'Yes',
            hint: 'Click Yes',
        },
        {
            id: 'No',
            text: 'No',
            hint: 'Click No',
        },
    ];

    const dollarPercentButtonItems: ToggleButtonItem[] = [
        {
            id: 'dollar',
            text: '$',
            hint: 'Click $',
        },
        {
            id: 'percent',
            text: '%',
            hint: 'Click %',
        },
    ];

    const onMoneyItemsChange = (item: string) => {
        set_moneySelected([item]);
    };

    const onYesItemsChange = (item: string) => {
        set_yesNoSelected([item]);
    };

    const onMoneyItemsChangeWithBubble = (item: string) => {
        set_moneyWithBubbleSelected([item]);
    };

    const onYesItemsChangewithBubble = (item: string) => {
        set_yesNoWithBubbleSelected([item]);
    };

    const onHorizontalYesItemsChange = (item: string) => {
        set_horizontalYesNoSelected([item]);
    };

    const onHorizontalMoneyItemsChange = (item: string) => {
        set_horizontalMoneySelected([item]);
    };

    const onHorizontalYesItemsChangeWithBubble = (item: string) => {
        set_horizontalYesNoWithBubbleSelected([item]);
    };

    const onHorizontalMoneyItemsChangeWithBubble = (item: string) => {
        set_horizontalMoneyWithBubbleSelected([item]);
    };

    return (
        <DemoPage
            title='Toggle Button :'
            sections={sections}
        >
            <DemoPageSection
                id={sections[0].id}
                title={sections[0].title}
            >
                <Panel
                    theme={PanelTheme.White}
                    width='650px'
                >
                    <DemoExample>
                        <ToggleButton
                            id='toggleButtonDemoYesNo'
                            items={yesNoButtonItems}
                            selectedItems={yesNoSelected}
                            stylingMode='outlined'
                            selectionMode='single'
                            onItemClick={(e) => onYesItemsChange(e?.itemData.id)}
                            width='250px'
                        />
                    </DemoExample>
                    <DemoExample>
                        <ToggleButton
                            id='toggleButtonDemoPercentDollar'
                            items={dollarPercentButtonItems}
                            selectedItems={moneySelected}
                            stylingMode='outlined'
                            selectionMode='single'
                            onItemClick={(e) => onMoneyItemsChange(e?.itemData.id)}
                            width='250px'
                        />
                    </DemoExample>
                    <DemoExample>
                        <ToggleButton
                            id='toggleButtonDemoYesNo'
                            items={yesNoButtonItems}
                            selectedItems={yesNoSelectedWithBubble}
                            stylingMode='outlined'
                            selectionMode='single'
                            onItemClick={(e) => onYesItemsChangewithBubble(e?.itemData.id)}
                            width='250px'
                            label='Yes / No Toggle with label'
                            showInfoIcon={true}
                            infoText='Yes / No Toggle with label'
                        />
                    </DemoExample>
                    <DemoExample>
                        <ToggleButton
                            id='toggleButtonDemoPercentDollar'
                            items={dollarPercentButtonItems}
                            selectedItems={moneySelectedWithBubble}
                            stylingMode='outlined'
                            selectionMode='single'
                            onItemClick={(e) => onMoneyItemsChangeWithBubble(e?.itemData.id)}
                            width='250px'
                            label='Toggle with label'
                            showInfoIcon={true}
                            infoText='Yes / No Toggle with label'
                        />
                    </DemoExample>
                </Panel>
            </DemoPageSection>
            <DemoPageSection
                id={sections[1].id}
                title={sections[1].title}
            >
                <Panel
                    theme={PanelTheme.White}
                    width='650px'
                >
                    <DemoExample>
                        <ToggleButton
                            id='toggleButtonDemoYesNoHorizontal'
                            items={yesNoButtonItems}
                            selectedItems={horizontalYesNoSelected}
                            stylingMode='outlined'
                            selectionMode='single'
                            onItemClick={(e) => onHorizontalYesItemsChange(e?.itemData.id)}
                            width='250px'
                            label='Yes / No Toggle (Horiz.)'
                            layoutStyle={ToggleButtonLayoutStyle.Horizontal}
                            labelWidth={horizontalLabelWidth}
                        />
                    </DemoExample>
                    <DemoExample>
                        <ToggleButton
                            id='toggleButtonDemoPercentDollarHorizontal'
                            items={dollarPercentButtonItems}
                            selectedItems={horizontalMoneySelected}
                            stylingMode='outlined'
                            selectionMode='single'
                            onItemClick={(e) => onHorizontalMoneyItemsChange(e?.itemData.id)}
                            width='250px'
                            label='$ / % Toggle (Horiz.)'
                            layoutStyle={ToggleButtonLayoutStyle.Horizontal}
                            labelWidth={horizontalLabelWidth}
                        />
                    </DemoExample>
                    <DemoExample>
                        <ToggleButton
                            id='toggleButtonDemoYesNoWithBubbleHorizontal'
                            items={yesNoButtonItems}
                            selectedItems={horizontalYesNoSelectedWithBubble}
                            stylingMode='outlined'
                            selectionMode='single'
                            onItemClick={(e) => onHorizontalYesItemsChangeWithBubble(e?.itemData.id)}
                            width='250px'
                            label='Yes / No Toggle with label (Horiz.)'
                            showInfoIcon={true}
                            infoText='Yes / No Toggle with label'
                            layoutStyle={ToggleButtonLayoutStyle.Horizontal}
                            labelWidth={horizontalLabelWidth}
                        />
                    </DemoExample>
                    <DemoExample>
                        <ToggleButton
                            id='toggleButtonDemoPercentDollarWithBubbleHorizontal'
                            items={dollarPercentButtonItems}
                            selectedItems={horizontalMoneySelectedWithBubble}
                            stylingMode='outlined'
                            selectionMode='single'
                            onItemClick={(e) => onHorizontalMoneyItemsChangeWithBubble(e?.itemData.id)}
                            width='250px'
                            label='Toggle with label (Horiz.)'
                            showInfoIcon={true}
                            infoText='Yes / No Toggle with label'
                            layoutStyle={ToggleButtonLayoutStyle.Horizontal}
                            labelWidth={horizontalLabelWidth}
                        />
                    </DemoExample>
                </Panel>
            </DemoPageSection>
        </DemoPage>
    );
};
